<template>
  <div
    id="app"
    class="relative grid h-screen p-8 text-gray-900 bg-gray-100 dark:text-white dark:bg-gray-900"
    style="grid-template-rows: auto 1fr auto auto"
  >
    <roll-box />

    <log-box />

    <div class="grid w-full max-w-md grid-cols-5 gap-2 mx-auto mt-6">
      <die-button
        v-for="(die, index) in dice"
        :key="index"
        @click.native="roll({ notation: die, name: 'Dice roll' })"
        >{{ die }}</die-button
      >
      <die-button @click.native="showFormulaModal">f(x)</die-button>
    </div>

    <div class="flex w-full max-w-md mx-auto mt-8 space-x-4">
      <button
        class="flex-1 h-12 p-2 font-medium border-2 border-blue-600 rounded-md dark:text-white focus:outline-none"
        @click="showFavoritesModal"
      >
        Favorites
      </button>
      <button
        class="flex-1 h-12 p-2 font-medium border-2 border-blue-600 rounded-md dark:text-white focus:outline-none"
        @click="showSettingsModal"
      >
        Settings
      </button>
    </div>

    <formula-modal />

    <favorites-modal />

    <settings-modal />

    <portal-target name="modals" />

    <content-update-notification />
  </div>
</template>

<script>
import RollBox from "./components/RollBox";
import LogBox from "./components/LogBox";
import DieButton from "./components/DieButton";
import FormulaModal from "./components/FormulaModal.vue";
import FavoritesModal from "./components/FavoritesModal";
import SettingsModal from "./components/SettingsModal.vue";
import ContentUpdateNotification from "./components/ContentUpdateNotification";

import { get, call } from "vuex-pathify";

export default {
  name: "App",
  components: {
    LogBox,
    RollBox,
    DieButton,
    FormulaModal,
    FavoritesModal,
    SettingsModal,
    ContentUpdateNotification,
  },
  data() {
    return {
      dice: ["d100", "d20", "d12", "d10", "d8", "d6", "d4", "d3", "d2"],
    };
  },
  computed: {
    lastRoll: get("lastRoll"),
    darkMode: get("darkMode"),
  },
  watch: {
    darkMode(value) {
      if (value == true) {
        document.querySelector("html").classList.add("dark");
      } else {
        document.querySelector("html").classList.remove("dark");
      }
    },
  },
  methods: {
    roll: call("roll"),
    showFormulaModal: call("showFormulaModal"),
    showFavoritesModal: call("showFavoritesModal"),
    showSettingsModal: call("showSettingsModal"),
  },
  mounted() {
    if (this.darkMode == true) {
      document.querySelector("html").classList.add("dark");
    }
  },
};
</script>

<style>
body {
  overscroll-behavior-y: none;
}

.log-list-enter-active,
.log-list-leave-active {
  transition: all 0.15s;
}
.log-list-enter,
.log-list-leave-to {
  opacity: 0;
  transform: translateX(4rem);
}
.log-list-move {
  transition: transform 0.15s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.lift-enter-active,
.lift-leave-active {
  transition: transform 0.15s;
}
.lift-enter,
.lift-leave-to {
  transform: translateY(100%);
}
</style>
